import React, { useState, FormEvent } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../api';
import AuthHeader from '../components/Header/AuthHeader';
import Button from '../components/Button';

interface LocationState {
  email?: string;
}

const SifremiUnuttumYeniSifre: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const stateEmail = (location.state as LocationState | null)?.email ?? '';
  const [email, setEmail] = useState<string>(stateEmail);
  const [forgotPasswordCode, setForgotPasswordCode] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setError('');

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setError('E-posta adresi girin.');
      return;
    }

    const code = forgotPasswordCode.trim();
    const codeNum = code === '' ? NaN : parseInt(code, 10);
    if (!Number.isInteger(codeNum)) {
      setError('Geçerli bir doğrulama kodu girin.');
      return;
    }

    if (newPassword !== newPasswordConfirmation) {
      setError('Yeni şifre ve tekrar alanları eşleşmiyor.');
      return;
    }

    if (newPassword.length < 1) {
      setError('Yeni şifre girin.');
      return;
    }

    setLoading(true);
    try {
      const result = await authService.changeForgottenPassword({
        email: trimmedEmail,
        forgotPasswordCode: codeNum,
        newPassword,
        newPasswordConfirmation,
      });
      if (result.isSuccess) {
        navigate('/giris', { state: { fromForgotPassword: true } });
      } else {
        setError(result.message ?? 'Şifre güncellenemedi. Lütfen bilgilerinizi kontrol edin.');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthHeader />
      <div className="sb-page-bg min-vh-100 d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <div className="card shadow-sm">
                <div className="card-body p-4">
                  <h4 className="card-title text-center mb-4">
                    Yeni Şifre Belirle
                  </h4>
                  <div className="text-muted text-center mb-4">
                    E-posta adresinizi, e-postanıza gelen kodu ve yeni şifrenizi girin.
                  </div>

                  {error && (
                    <div className="alert alert-danger mb-3" role="alert">
                      {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="email">
                        E-posta
                      </label>
                      <input
                        className="form-control"
                        id="email"
                        type="email"
                        required
                        placeholder="ornek@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="forgotPasswordCode">
                        Doğrulama Kodu
                      </label>
                      <input
                        className="form-control"
                        id="forgotPasswordCode"
                        type="number"
                        required
                        placeholder="Kodu girin"
                        value={forgotPasswordCode}
                        onChange={(e) => setForgotPasswordCode(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="newPassword">
                        Yeni Şifre
                      </label>
                      <input
                        className="form-control"
                        id="newPassword"
                        type="password"
                        required
                        minLength={1}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="form-label" htmlFor="newPasswordConfirmation">
                        Yeni Şifre (Tekrar)
                      </label>
                      <input
                        className="form-control"
                        id="newPasswordConfirmation"
                        type="password"
                        required
                        minLength={1}
                        value={newPasswordConfirmation}
                        onChange={(e) => setNewPasswordConfirmation(e.target.value)}
                      />
                    </div>
                    <Button
                      className="btn btn-primary w-100 mb-3"
                      type="submit"
                      loading={loading}
                    >
                      Şifremi Güncelle
                    </Button>
                    <div className="text-center">
                      <Link className="text-decoration-none" to="/sifremi-unuttum">
                        <i className="fas fa-arrow-left me-1" />
                        Kod gönder sayfasına dön
                      </Link>
                      <span className="mx-2 text-muted">|</span>
                      <Link className="text-decoration-none" to="/giris">
                        Giriş sayfasına dön
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SifremiUnuttumYeniSifre;
